import axios from 'axios';

export default {
  payPlan: (paymentPlanId, payload = {}, config = {}) => axios.post(`payments/${paymentPlanId}/pay`, payload, config),
};
